// @flow

import { observer } from "mobx-react";
import React from "react";

import Video from "app/models/Video";

import VideoCard from "app/components/VideoCard/VideoCard";
import FolderStore from "app/stores/FolderStore";

import "./VideoCards.scss";

type Props = {
    videos: Video[],
    serverTime: any,
    theme: string,
    breakpointClasses?: string,
    showTimestamp?: boolean,
    timelineThumbnail?: boolean,
    onlyTimeline: ?boolean,
    isDashboard: ?boollan
};

@observer
export default class VideoCards extends React.Component<Props> {
    render() {
        if (!this.props.videos) {
            return this.renderEmptyList();
        }

        const classes = ["VideoCards"];

        return <div className={classes.join(" ")}>
            { 
                this.props.isDashboard && FolderStore.selected && 
                <h2 className="VideoCards__folder_title"><i className="fa fa-folder-open"></i> {FolderStore.selected.name}</h2>
            }
            {this.renderItems()}
        </div>;
    }

    renderItems() {
        const videos = this.props.videos;
        if (!videos.length) return this.renderEmptyList();

        if (this.props.isDashboard && FolderStore.selected && FolderStore.selected.video_count === 0) return this.renderEmptyList();

        const breakpointClasses =
            this.props.breakpointClasses || "col-lg-3 col-md-4 col-sm-6";

        const items = this.props.videos.map((video, index) => {

            if (this.props.isDashboard && video.folder_id !== FolderStore.selectedId) return null;

            return (
                <div key={index} className={breakpointClasses}>
                    <VideoCard
                        video={video}
                        items={video.items}
                        theme={this.props.theme}
                        serverTime={this.props.serverTime}
                        showTimestamp={this.props.showTimestamp}
                        timelineThumbnail={this.props.timelineThumbnail}
                        showUnpublishedWarning={this.props.isDashboard}
                        showFolderMove={this.props.isDashboard}
                        onlyTimeline={this.props.onlyTimeline}
                    />
                </div>
            );
        });

        return <div className="VideoCards__items row">{items}</div>;
    }

    renderEmptyList() {
        return <div className="well">No videos found</div>;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/VideoCards/VideoCards.js